<template>
  <div
    class="TransactionList">
    <SummaryDialog
      v-model="sumOfTrans.isDisplay"
      :sumOfTrans="sumOfTrans"
    />
    <TransactionCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadCRUDList"
    />
    <CRUDList
      ref="crudList"
      :canAdd="true"
      :canEdit="true"
      :canApply="true"
      :canSave="false"
      :headers="headers"
      :showSelect="true"
      :showDate="true"
      :showTotal="true"
      :baseCrudKey="baseCrudKey"
      :createNewItem="newItemDialog"
      :selectedItems="selectedItems"
      :itemTotal="selectedItemsAmount"
      :defaultSortBy="sortBy"
      :uploadFileParams="uploadFileParams"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      overrideApplyBtnLabel="SAVE"
      toolbarTitle="Mortgage Tax"
      @loadCRUDList="handleLoadCRUDList"
      @upsertItem="upsrtTransaction"
      @deleteItem="deleteTransaction"
      @emitSelectedItem="emitSelectedItem"
      @activateItem="activateTransaction"
    >
      <template v-slot:[`editedItem`]="{}">
        <TransactionEditedItem ref="edit"
          :baseCrudKey="baseCrudKey"
          :attachmentConstants="attachmentConstants"
          :cmnEnums="cmnEnums"
          @emitEditBatchPaymntItem="handleBatchPaymntDetailsEditItem"
          @editItem="editItem"
          @voidTransactionOnSave="onVoidTransactionOnSave"
          @payrixSuccess="handlePayrixSuccess"
        />
      </template>

      <template v-slot:[`additionalActionTitle`]="{}">
          <v-btn
          text color="blue darken-1"
          title='CTRL + "'
          @click = "dittoBtn()">
          DITTO (ctrl + “) </v-btn>
        </template>

      <template v-slot:[`additionalActions`]="{}">
        <v-row>
          <v-btn
            id="mtgTransPrintFormatBtn"
            class="mtg-trans-print-format-btn"
            text color="blue darken-1"
            @click="mtgPrintReceiptFromDialogBox()">
          Print Receipt</v-btn>
        </v-row>
        <AuditDialog
          class="mtg-trans-audit-dialog"
          v-if="getActiveTransID"
          :identifier="getActiveTransID"
          activatorCaption="Audit History"
        />
        <UploadFile
          class="mtgtrans uploadFile"
          :bucketName="attachmentConstants.bucketName"
          :program="attachmentConstants.program"
          :parentObjectType="attachmentConstants.parentObjectType"
          :parentObjectId="getActiveTransID || ''"
          :itemIsSaved="!isNewItem"
        ><template v-slot:activator="{ activatorProps }">
        <v-btn
          color="primary"
          text
          @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
          @click="imagesLeftClick(activatorProps.leftClick)"
        >
        {{activatorProps.caption}}
        </v-btn>
        </template>
       </UploadFile>
      </template>
      <template v-slot:[`additionalActionsAfterSave`]="{}">
              <v-btn class="mtg-transaction-list-save-print-btn"
    id="mtgTransactionListSavePrintBtn"
    text color="blue darken-1"
    @click="onSaveClick(true)">Save & print</v-btn>
      </template>

        <!-- Only Super Admin Should Delete -->
      <template v-slot:[`canDeleteSlot`]="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon id="mtgTransListDeleteIcon"
              class="mx-2 mtg-translist-delete-icon" color="primary"
              fab icon small
              v-bind="attrs"
              v-on="on"
              v-if="isSuperAdmin"
              :disabled="(selectedItems || []).length === 0"
              @click="deleteItems"
            >
              {{icons.mdiDelete}}
            </v-icon>
          </template>
            <span>Delete</span>
        </v-tooltip>
         <v-divider
          class="mx-4" inset vertical
        ></v-divider>
      </template>

      <template v-slot:[`additionalToolsAtRight`]="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
          <v-btn id="mtgTranListPrintReceiptBtn"
            class="mtg-translist-print-receipt-icon"
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="mtgPrintReceiptOutsideDialogBox()"
          >
          <v-icon left>
            {{ icons.mdiPrinter }}
          </v-icon>
          Receipt
          </v-btn>
          </template>
            <span>Print Receipt</span>
        </v-tooltip>
        <v-divider
          v-if="isCscActivated"
          class="mx-4" inset vertical
        ></v-divider>
        <v-tooltip v-if="isCscActivated" bottom>
          <template v-slot:activator="{ on, attrs }">
            <CscImportDialog
              :closeDialogBox="closeCSCDialogBox"
              :baseCrudKey="baseCrudKey"
              @handleLoadCRUDList="handleLoadCRUDList"
              @fetchAmountTotal="fetchAmountTotal"
              @settingDialogVal="settingCSCDialogVal"
            />
          <v-btn id="mtgTranListCscImport"
            class="mtg-translist-csc-import-icon"
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="openCscComponent"
          >
          <v-icon left>
            {{ icons.mdiImport }}
          </v-icon>
          Import CSC
          </v-btn>
          </template>
            <span>Import from CSC</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
        <div v-if="selectedItemsAmount !==0"
        :class="selectedItemsAmount < 0 ? 'red--text' : '' "
             >
             {{`Total: ${amountFormat(selectedItemsAmount)}`}}
          </div>
      </template>
      <template v-slot:[`bulkMarking`]="{}"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on,attrs }">
            <transactionNumber
              v-if="forceReloadDetails"
              :cmnBaseCrudKey="baseCrudKey"
              :cmnEnums="cmnEnums"
              :closeDialogBox="closeDialogBox"
              :criteriaStateFY="criteriaState.fiscalYear"
              :selectedItemsAmount="selectedItemsAmount"
              :selectedItems="selectedItems"
              :isNewItem="isNewBatchPaymentTransaction"
              :batchPaymentDetailsEditItem="transNoObject"
              :programType="'MTG'"
              @settingDialogVal="settingDialogVal"
              @transactionNumberObj="transactionNumberObj"
              @deleteBatchPaymentDetails="deleteBatchPaymentDetails"
              />
            <v-btn v-bind="attrs" v-on="on"
            class="mx-2" color="primary"
            fab icon small
            :disabled="(selectedItems || []).length === 0"
            @click="openComponent"
            >
              <v-icon>
                {{icons.mdiAlphaBCircle}}
              </v-icon>
            </v-btn>
          </template>
           <span>Batch Pay</span>
        </v-tooltip>
        <v-divider
          class="mx-4" inset vertical
        ></v-divider>
      </template>
    </CRUDList>

    <CRUDDialog baseCrudKey="mtgVoidAuditRecord" :canCancel="false"
      @upsertItem="upsertAuditTransactionForVoids">
      <template v-slot:[`editedItem`]="{}">
        <auditRecord baseCrudKey="mtgVoidAuditRecord" />
      </template>
    </CRUDDialog>
  </div>
</template>

<script>
import {
  mdiDelete,
  mdiPrinter,
  mdiAlphaBCircle,
  mdiImport,
} from '@mdi/js';
import {
  mapGetters,
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import TransactionCriteria from './TransactionCriteria.vue';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import TransactionEditedItem from './TransactionEditedItem.vue';
import transactionNumber from '../../common/transactionNumber/transactionNumber.vue';
import UploadFile from '../../common/UploadFile.vue';
import AuditDialog from '../../common/audit/AuditDialog.vue';
import {
  calculateFiscalYears,
  getBusinessDateForPaymentEntry,
  toFiscalYear,
  toIsoDate,
  toShortDate,
  updateDateFormat,
} from '../../../util/shared/tmc-global';
import {
  amountToNumber,
  isEmptyObject,
  // defaultOverlayConfig,
  defaultGridLoading,
  manageGridLoading,
  extractId,
  isAltR,
  checkStringEmptiness,
  amountFormat,
} from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';
import CscImportDialog from './CscImportDialog.vue';
import { mtgAllPaymentTypeObj, updateDescription } from './MtgTransactionHelper';
import { getWorkstationNumber } from '../../../util/workstation-util';
import MtgTransactionList from './MtgTransactionList.mixin';
import SummaryDialog from './SummaryDialog.vue';
import { authRoles } from '../../../router/roleGroups';
import { isAuthorised } from '../../../store/auth/token';
import { generateQueryString } from '../../common/base/report/report-util';
import { determineCssProps } from './determine-css-props.util';
import { printerHandler } from '../../../util/pdf-to-printer.util';
import { TMC_CONSTANTS } from '../../../util/shared/constants';
import CRUDDialog from '../../common/base/crud/CRUDDialog.vue';
import auditRecord from '../../tax/payments/audit/auditRecord.vue';

const { MTG_CONSTANTS } = TMC_CONSTANTS;

const getDefaultSumOfTrans = () => ({ isDisplay: false, totalAmt: 0.0, totalCount: 0 });

const { backendRest } = clients.direct;

const getHeaders = () => {
  const headers = [
    {
      text: 'Attachments', value: 'hasFiles', sortable: false, formatter: 'file',
    },
    {
      text: 'Date', value: 'businessDate', width: '10%', formatter: 'shortDate',
    },
    { text: 'Rec#', value: 'receiptNumber' },
    { text: 'Wkst', value: 'wkst' },
    { text: 'Mortgagor', value: 'mortgagor' },
    { text: 'Received Of', value: 'receivedOf' },
    { text: 'Rate', value: 'rateOfTax' },
    {
      text: 'Mortgage Amount', value: 'amount', formatter: 'amount', align: 'right',
    },
    {
      text: 'Mortgage Tax', value: 'mortgageTax', formatter: 'amount', align: 'right',
    },
    { text: 'Fee', value: 'fee' },
    { text: 'Term(Yrs)', value: 'termYear' },
  ];
  return headers;
};

const bankCrudKey = 'sharedBank';

const postProcessMtg = (mtgTransactions) => {
  const buildPostProcessData = (transaction) => ({
    ...transaction,
  });

  let processedData;
  if (Array.isArray(mtgTransactions)) {
    processedData = mtgTransactions.map((transaction) => {
      const updatedTransaction = { ...transaction };
      updatedTransaction.crudRowCssAppend = determineCssProps(updatedTransaction);
      return buildPostProcessData(updatedTransaction);
    });
  } else {
    const updatedTransaction = { ...mtgTransactions };
    updatedTransaction.crudRowCssAppend = determineCssProps(updatedTransaction);
    processedData = buildPostProcessData(updatedTransaction);
  }
  return processedData;
};

export default {
  mixins: [MtgTransactionList],
  data: () => ({
    baseCrudKey: 'mtgTransaction',
    baseCrudKeyForReasonCodes: 'reasonCodesBaseCrudKey',
    headers: [],
    dateForCriteria: ['fromBusinessDate', 'toBusinessDate'],
    activeTransItem: undefined,
    selectedComponent: null,
    cmnBaseCrudKey: 'mtgPaymentDetailForTransactionNumber',
    closeDialogBox: false,
    closeCSCDialogBox: false,
    forceReloadDetails: false,
    transNoObject: {},
    activeEditedItem: {},
    attachmentConstants: {
      bucketName: 'mtg',
      program: 'mtg',
      parentObjectType: 'mtgTransaction',
    },
    uploadFileParams: {
      bucketName: 'mtg',
      program: 'mtg',
      parentObjectType: 'mtgTransaction',
    },
    uploadFileClickParams: {
      leftClickFlag: false,
      leftClickDef: undefined,
      rightClickFlag: false,
      rightClickDef: undefined,
    },
    icons: {
      mdiDelete,
      mdiPrinter,
      mdiAlphaBCircle,
      mdiImport,
    },
    gridLoading: defaultGridLoading(),
    sortBy: [
      {
        column: 'businessDate',
        direction: 'desc',
      },
      {
        column: 'receiptNumber',
        direction: 'desc',
      },
    ],
    isNewBatchPaymentTransaction: false,
    sumOfTrans: getDefaultSumOfTrans(),
    reasonCodeForComments: '',
    tempItem: {},
    shouldOpenVoidAuditSummary: false,
  }),
  created() {
    window.addEventListener('keydown', this.shortcutHandler);
    this.headers = getHeaders();
    this.initCriteria();
    this.initializeMtgFiscalYears();
  },
  destroyed() {
    window.removeEventListener('keydown', this.shortcutHandler);
  },
  components: {
    CRUDList,
    CRUDDialog,
    TransactionCriteria,
    TransactionEditedItem,
    CscImportDialog,
    UploadFile,
    AuditDialog,
    transactionNumber,
    SummaryDialog,
    auditRecord,
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
      'items',
    ]),
    ...mapGetters('auth/token', [
      'authUser',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      mtgRegYears: (state) => state.mtg.mtgTransaction.regYears,
      storedSelectedItems: (state) => state.mtg.mtgTransaction.selectedItems,
      nextReceiptNumber: (state) => state.mtg.mtgTransaction.nextReceiptNumber,
      mtgSettingItem: (state) => state.SystemConfig.mtgSettingItem,
      businessDateRange: (state) => state.mtg.mtgTransaction.businessDateRange,
      cmnEnums(state) {
        return this.mapBankToPaymentType(state.enums);
      },
      devSetting: (state) => state.SystemConfig.devSettingItem || {},
      mtgDittoStoreValues: (state) => state.mtg.mtgTransaction.mtgDittoButtonStore || {},
      exemptMortgageesArrList: (state) => state.base.crud.items.exemptMortgageesArrList || [],
      reasonListDropDown: (state) => state.base.crud.items.reasonCodesBaseCrudKey || [],
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    selectedItems: {
      get() {
        return this.storedSelectedItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    fiscalYearList() {
      const registerdYears = (this.mtgRegYears || {});
      const allowAll = true;
      return calculateFiscalYears(registerdYears, allowAll);
    },
    selectedItemsAmount() {
      const amountSum = (this.selectedItems || []).reduce((acc, obj) => acc
        + amountToNumber(obj.amount), 0);
      return amountSum;
    },
    isSuperAdmin() {
      return isAuthorised(authRoles.SuperAdmin);
    },
    isCscActivated() {
      return this.mtgSettingItem.activateCsc;
    },
    rules() {
      return [
        (value) => !!value || 'Required',
      ];
    },
  },
  methods: {
    amountFormat,
    manageGridLoading,
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions(['reAuth', 'flashError']),
    ...mapActions(['flashInfo', 'flashSuccess']),
    ...mapActions('tax/taxPayment', [
      'upsertTaxPaymentAudits',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('mtg/mtgTransaction', [
      'loadMtgTransaction',
      'exemptMortgageesForMtg',
      'upsertMtgTrans',
      'deleteMtgTransaction',
      'loadFiscalRegYears',
      'loadLastReceiptNo',
      'loadLastTransactionNo',
      'loadBusinessDateRange',
      'mtgStatsImportSummary',
    ]),
    ...mapMutations('files', [
      'setFiles',
    ]),
    ...mapMutations('mtg/mtgTransaction', [
      'setSelectedItems',
      'setReceiptPulse',
      'setReceiptPolling',
      'setMortgageData',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItem',
      'setIndex',
      'setIsVisible',
    ]),
    ...mapActions('common/cmnWhom', [
      'loadCmnWhom',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItem',
      'setIndex',
    ]),
    ...mapMutations('common/cmnTransNumber', [
      'setTransNoPolling',
      'setTransNoPulse',
    ]),
    dittoBtn() {
      this.$refs.edit.ditto();
    },
    handleBatchPaymntDetailsEditItem(item) {
      this.transNoObject = JSON.parse(JSON.stringify(item));
      this.isNewBatchPaymentTransaction = false;
      this.closeDialogBox = true;
      this.forceReloadDetails = true;
      return this.transNoObject;
    },
    async handleLoadCRUDList(criteriaArgs = {}) {
      const { baseCrudKey } = this;
      const criteria = this.updateCriteriaForReq();
      // eslint-disable-next-line max-len
      // fiscalYear '0' means all-year & 'null' is a default value, don't call api if not a valid FY value
      if (criteria.fiscalYear !== 0 && !Number(criteria.fiscalYear)) return;
      manageGridLoading(this, true, 'Searching...');
      this.loadMtgTransaction({
        criteria,
        baseCrudKey,
        criteriaArgs,
        postProcessTransaction: postProcessMtg,
      }).then(() => {
        this.setDefaultSelectedItems(criteriaArgs);
      }).catch((e) => {
        console.warn(e);
        this.setDefaultSelectedItems(criteriaArgs);
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    initCriteria() {
      // reset criteria while merge flag is true
      this.criteriaState = {};
      // 'null' keeping a string value so can put the `Number()` logic
      this.criteriaState.fiscalYear = 'null';
      this.criteriaState = { ...this.criteriaState, ...this.handleQuery() };
      this.exemptMortgageesForMtg({
        baseCrudKey: 'exemptMortgageesArrList',
        criteria: {},
        postProcessTransaction: this.postProcessExemptMortgagees,
      });
    },
    postProcessExemptMortgagees(exemptMortgagees) {
      const exemptMortgageesList = (exemptMortgagees || []).map((dt) => (
        dt.exemptMortgagees
      ));
      return exemptMortgageesList;
    },
    async initializeMtgFiscalYears() {
      await this.loadFiscalRegYears({ baseCrudKey: this.baseCrudKey });
      const regYears = this.fiscalYearList || [];
      if ((regYears || []).length > 0) {
        this.criteriaState.fiscalYear = (regYears[regYears.length - 1] || {}).year;
      }
      this.handleLoadCRUDList();
      this.loadLists(this.criteriaState.fiscalYear);
    },
    updateCriteriaForReq() {
      const updatedCriteria = updateDateFormat(this.criteriaState, this.dateForCriteria);
      return updatedCriteria;
    },
    async upsrtTransaction(item, closeDialog = true) {
      /* For new item check wkst, and if it is not avaible exit early with message */
      if (this.isNewItem && !item.wkst) {
        this.flashError('Error: While upserting receipt, workstation number not exist!');
        return {};
      }
      if (this.isNewItem) {
        this.setMortgageData(item);
      }

      const fullAmount = amountToNumber(item.amount);
      const amountPaid = (item.paymentDetails
        || []).reduce((sum, detail) => sum + (detail.amount ? amountToNumber(detail.amount) : 0.00),
        0.00);

      const formattedAmountPaid = amountToNumber(amountPaid);
      const isPaidInFull = fullAmount === formattedAmountPaid;
      if (!this.activeEditedItem.transactionNumberObject && !isPaidInFull) {
        const proceed = window.confirm('The payment amount does not match the amount due. Do you wish to proceed?');
        if (!proceed) return null;
      }

      if (closeDialog) {
        this.$refs.crudList.$refs.crudDialog.close();
      }

      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      delete updatedItem.hasFiles;
      delete updatedItem.crudRowCssAppend;
      if (checkStringEmptiness(updatedItem.mortgageDueDate)) {
        updatedItem.mortgageDueDate = null;
      }
      if (checkStringEmptiness(updatedItem.dateOfMortgage)) {
        updatedItem.dateOfMortgage = null;
      }
      updatedItem.amount = amountToNumber(updatedItem.amount);
      updatedItem.fee = amountToNumber(updatedItem.fee);
      updatedItem.mortgageTax = amountToNumber(updatedItem.mortgageTax);
      updatedItem.rateOfTax = amountToNumber(updatedItem.rateOfTax);
      updatedItem.termYear = amountToNumber(updatedItem.termYear);
      updatedItem.mortgageAmount = amountToNumber(updatedItem.mortgageAmount);
      if (updatedItem.transactionNumberObject) {
        updatedItem.transactionNumberObject = extractId(updatedItem.transactionNumberObject);
      }
      if ((updatedItem.paymentDetails || []).length > 0) {
        const newPaymentDetails = [];
        for (let i = 0; i < updatedItem.paymentDetails.length; i += 1) {
          const element = updatedItem.paymentDetails[i];
          const newUpdatedElement = this.buildPaymentItem(element);
          // if paymentType is empty, do not push the paymentDetails
          if (newUpdatedElement.paymentType) {
            newPaymentDetails.push({
              ...newUpdatedElement,
            });
          }
        }
        updatedItem.paymentDetails = newPaymentDetails;
      }
      /*
        Trying to reduce the chance of skipping receipt number,
        stopping polling just before upserting
      */
      this.setReceiptPolling(undefined);
      this.setTransNoPolling(undefined);
      this.reasonCodeForComments = ''; // reset reason code for comments
      const response = await this.upsertMtgTrans({
        item: updatedItem,
        baseCrudKey,
        postProcessTransaction: postProcessMtg,
      });
      const shouldOpenVoidAudit = this.shouldOpenVoidAuditSummary && !!updatedItem.isVoid;
      this.checkForVoid(response);
      if (!isEmptyObject(response)) {
        this.updateActiveTransItem(response);
        if (shouldOpenVoidAudit && response._id) {
          this.openVoidAuditSummaryDialog(response);
        }
      }
      this.setDefaultSelectedItems();
      return response;
    },
    checkForVoid(item) {
      this.tempItem = item;
    },
    upsertReasonCode() {
      if (this.reasonCodeForComments) {
        const updatedItem = { ...this.tempItem };
        if (updatedItem.commentsForInternalUse) {
          updatedItem.commentsForInternalUse = `${updatedItem.commentsForInternalUse}\n${this.reasonCodeForComments}`;
        } else {
          updatedItem.commentsForInternalUse = this.reasonCodeForComments;
        }
        // tempItem carries a populated transactionNumberObject straight from the GraphQL
        // response when this void is part of a batch payment — same shape upsrtTransaction
        // expects from the crud dialog, so reuse it to flatten that ref instead of sending
        // the populated object straight through (that 500s: "Expected type ID").
        this.upsrtTransaction(updatedItem, false);
      }
    },
    buildPaymentItem(element) {
      if (element.paymentType) {
        const amount = amountToNumber(element.amount);
        const updatedElement = {
          paymentType: element.paymentType,
          isReconcilled: element.isReconcilled,
          amount,
        };
        if (element.paymentType === 'CASH') {
          updatedElement.cashReceived = amountToNumber(element.cashReceived);
          updatedElement.cashChange = amountToNumber(element.cashChange);
        }
        if (element.paymentType === 'CREDIT') {
          updatedElement.creditType = element.creditType;
        }
        if (element.paymentType === 'CHECK') {
          updatedElement.checkNumber = element.checkNumber;
          updatedElement.checkPaidBy = element.checkPaidBy;
        }
        if (element.paymentType === 'EFT') {
          updatedElement.eftType = element.eftType;
        }
        return { ...updatedElement };
      }
      return { ...element };
    },
    deleteTransaction(item) {
      const { baseCrudKey } = this;
      this.deleteMtgTransaction({ item, baseCrudKey }).then(() => {
        this.selectedItems = [];
      }).catch((e) => {
        console.warn(e);
        this.selectedItems = [];
      });
    },
    async deleteItems() {
      if (window.confirm(`CAREFUL! Are you sure you want to DELETE ${this.selectedItems.length} record/s?`)) {
        for (let i = 0; i < (this.selectedItems || []).length; i += 1) {
          const item = this.selectedItems[i];
          this.deleteTransaction(item);
        }
      }
      this.selectedItems = [];
    },
    mapBankToPaymentType(stateArr) {
      const mtgSettingObj = { ...this.mtgSettingItem } || {};
      const bankArr = this.items(bankCrudKey) || [];
      const paymentTypeEnums = updateDescription(stateArr.mtgPaymentTypeEnum,
        mtgSettingObj, bankArr);
      const eftTypeEnums = updateDescription(stateArr.mtgEFTTypeEnum, mtgSettingObj, bankArr);
      const mtgPaymentObj = {
        cmnPaymentTypes: paymentTypeEnums,
        cmnEFTTypes: eftTypeEnums,
        cmnCardTypes: stateArr.mtgCCardTypeEnum || [],
      };
      return mtgPaymentObj;
    },
    async loadLists(fiscalYear) {
      const currentFiscalYear = fiscalYear || toFiscalYear(new Date(this.todaysDate));
      await this.loadConfig({ requiredScope: 'mtgConfig' });
      if (currentFiscalYear !== 'null') {
        this.loadCmnWhom({
          criteria: {
            fiscalYear: currentFiscalYear,
          },
          baseCrudKey: 'mtgWhom',
        });
      }
      this.loadBankData();
    },
    loadBankData() {
      const mtgSettingObj = { ...this.mtgSettingItem } || {};
      const paymentTypeIds = [];
      const enumFieldsArr = Object.values(mtgAllPaymentTypeObj);
      for (const enumValue of enumFieldsArr) {
        if (mtgSettingObj[enumValue]) {
          paymentTypeIds.push(mtgSettingObj[enumValue]);
        }
      }
      this.loadBanks({
        criteria: {
          _ids: paymentTypeIds,
          notEmptyAltKey: true,
          limit: 0,
        },
        baseCrudKey: bankCrudKey,
      });
    },
    async globalPtmConfig() {
      const globalSetting = await this.loadConfig({ requiredScope: 'global' });
      const paymentSetting = await this.loadConfig({ requiredScope: 'paymentConfig' });
      return { globalSetting, paymentSetting };
    },
    async businessDateDefault() {
      let registerOverride;
      if (this.isNewItem) {
        const { globalSetting, paymentSetting } = await this.globalPtmConfig();
        const payment = (paymentSetting[0] || []).configuration || {};
        const { configuration } = (globalSetting[0] || []);
        if (configuration.mtgTax && payment.changeBussDateIndividually) {
          registerOverride = getBusinessDateForPaymentEntry();
        } else if (configuration.mtgTax) {
          registerOverride = configuration.businessDate;
        } else {
          registerOverride = this.todaysDate;
        }
      }
      return toIsoDate(registerOverride);
    },
    newItemDialog() {
      this.setFiles([]);
      let newItem = {};
      newItem = {
        businessDate: this.todaysDate,
        fiscalYear: this.criteriaState.fiscalYear || toFiscalYear(new Date(this.todaysDate)),
        receiptNumber: null,
        receivedOf: '',
        mortgagor: '',
        mortgagee: '',
        // isVoid: '',
        amount: 0.00,
        remark: '',
        dateOfMortgage: null,
        mortgageDueDate: null,
        termYear: 0,
        mortgageAmount: 0.00,
        rateOfTax: 0.00,
        mortgageTax: 0.00,
        fee: MTG_CONSTANTS.MTG_CERTIFICATE_FEE,
        property: '',
        sectionLot: '',
        township: '',
        rangeBlk: '',
        wkst: null,
        transactionNumber: null,
        isExempt: false,
      };
      this.loadLastReceiptNo({ fiscalYear: newItem.fiscalYear });
      if (this.mtgSettingItem.defaultWkstNo) {
        newItem.wkst = this.mtgSettingItem.defaultWkstNo;
      } else {
        newItem.wkst = getWorkstationNumber();
      }
      newItem.amount = newItem.fee + newItem.mortgageTax;
      this.globalPtmConfig().then(({ globalSetting }) => {
        const global = ((globalSetting || [])[0] || {}).configuration || {};
        if (this.mtgSettingItem && this.mtgSettingItem.usedLastBusinessDate
          && !global.mtgTax
        ) {
          this.loadBusinessDateRange().then(() => {
            newItem.businessDate = new Date(this.businessDateRange.max) > new Date()
              ? this.businessDateRange.max : this.todaysDate;
          }).catch((e) => {
            console.warn(e);
            newItem.businessDate = this.todaysDate;
          });
        } else {
          this.businessDateDefault().then((res) => {
            newItem.businessDate = res;
          });
        }
      }).catch((e) => {
        console.warn(e);
      });
      return newItem;
    },
    emitSelectedItem(item) {
      this.selectedItems = item;
    },
    setDefaultSelectedItems(criteriaArgs = {}) {
      if (criteriaArgs.searchMode === 'wildcard') {
        this.$nextTick(() => {
          this.selectedItems = [...this.selectedItems];
        });
      } else {
        this.$nextTick(() => {
          this.selectedItems = [];
        });
      }
    },
    activateTransaction(val) {
      this.activeTransItem = val;
    },
    getChuckID() {
      return ((this.$route || {}).query || {}).chunkID;
    },
    async fetchAmountTotal(batchIDArr) {
      if (batchIDArr) {
        const result = await this.mtgStatsImportSummary({
          criteria: {
            batchIDArr,
          },
        });
        this.sumOfTrans.totalAmt = result.totalAmount;
        this.sumOfTrans.totalCount = result.count;
        this.sumOfTrans.isDisplay = true;
      }
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
        await this.upsrtTransaction(this.activeEditedItem, false);
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
        await this.upsrtTransaction(this.activeEditedItem, false);
      } else {
        rightClick();
      }
    },
    settingFields(res) {
      this.activeTransItem = res;
      this.setItem([this.baseCrudKey, res]);
      this.setIndex([this.baseCrudKey, 0]);
      this.setReceiptPolling(undefined);
      this.setTransNoPolling(undefined);
    },
    updateActiveTransItem(res) {
      if (this.uploadFileClickParams.leftClickFlag) {
        this.settingFields(res);
        this.$nextTick(() => {
          this.imagesLeftClick(this.uploadFileClickParams.leftClickDef);
          this.uploadFileClickParams.leftClickFlag = false;
          this.uploadFileClickParams.leftClickDef = undefined;
        });
      } else if (this.uploadFileClickParams.rightClickFlag) {
        this.settingFields(res);
        this.$nextTick(() => {
          this.imagesRightClick(this.uploadFileClickParams.rightClickDef);
          this.uploadFileClickParams.rightClickFlag = false;
          this.uploadFileClickParams.rightClickDef = undefined;
        });
      }
      return false;
    },
    handleQuery() {
      const chunkID = this.getChuckID();
      const paramsCriteria = {};
      if (chunkID) {
        paramsCriteria.chunkID = chunkID;
        // for bulk import set also set FY criteria (all years)
        paramsCriteria.fiscalYear = 0;
      }
      return paramsCriteria;
    },
    shortcutHandler(e) {
      if (isAltR(e)) {
        this.mtgPrintReceiptFromDialogBox();
      }
    },
    async upsertMtgData(closeDialog = false) {
      const result = await this.upsrtTransaction(this.activeEditedItem, closeDialog);
      if (result) {
        this.settingFields(result);
        return result._id;
      }
      return null;
    },
    async mtgPrintReceiptFromDialogBox() {
      const isValidForm = this.$refs.crudList.$refs.crudDialog.validateForm();
      if (isValidForm) {
        const mtgTransId = await this.upsertMtgData(false);
        if (mtgTransId) {
          this.printReceipt(mtgTransId);
        }
      }
    },
    async mtgPrintReceiptOutsideDialogBox() {
      const mtgTransId = this.selectedItems.map((t) => t._id).join(',');
      this.printReceipt(mtgTransId);
    },
    async printReceipt(mtgTransId) {
      const { jwt } = await this.reAuth();
      const params = [
        `mtgTransId=${mtgTransId}`,
        `token=${jwt}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/mtgPrintReceiptFormat${queryString}`;
      // window.open(url, '_blank');
      printerHandler(this, { url, reportName: 'mortgageTax', deafultPrinterMode: true });
    },
    requiredTransNoObject() {
      const updatedArray = [];
      for (let i = 0; i < (this.selectedItems || []).length; i += 1) {
        const item = { ...this.selectedItems[i] };
        if (this.isContainingDetails(item)) {
          updatedArray.push(item);
        }
      }
      return updatedArray;
    },
    openComponent() {
      const transObj = this.requiredTransNoObject();
      this.isNewBatchPaymentTransaction = true;
      if (transObj.length === this.selectedItems.length) {
        if (window.confirm(`Are you sure want to Batch Pay ${(this.selectedItems || []).length} record/s?`)) {
          // this.initBatchPaymentObject = {};
          this.closeDialogBox = true;
          this.forceReloadDetails = true;
        }
      } else {
        this.flashInfo('One or more transactions already contain Transaction Number.');
        this.selectedItems = [];
      }
    },
    openCscComponent() {
      this.closeCSCDialogBox = false;
      this.$nextTick(() => {
        this.closeCSCDialogBox = true;
      });
    },
    settingDialogVal(value) {
      this.closeDialogBox = value;
      // removing from dom
      this.forceReloadDetails = false;
      this.transNoObject = {};
    },
    settingCSCDialogVal(value) {
      this.closeCSCDialogBox = value;
    },
    async transactionNumberObj(transNumObj) {
      if (this.isNewBatchPaymentTransaction) {
        this.upsertBatchPaymentDetails(transNumObj);
      } else {
        this.handleTransactionsAfterBatchPayment([], { operation: 'update' });
      }
      this.selectedItems = [];
    },
    customCloseDialogBoxUtility() {
      this.setIsVisible([this.baseCrudKey, false]);
      this.$nextTick(() => {
        this.editedItem = { ...this.newItemDialog };
      });
    },
    onVoidTransactionOnSave(value) {
      this.shouldOpenVoidAuditSummary = !!value;
    },
    openVoidAuditSummaryDialog(response) {
      this.activeTransItem = response;
      this.shouldOpenVoidAuditSummary = false;
      const voidItem = {
        reciept: String(response.receiptNumber || ''),
        businessdate: toShortDate(response.businessDate),
        workstation: Number(response.wkst) || 0,
        auditSummary: 'Mortgage Tax Receipt Voided',
        auditReason: '',
        user: this.authUser,
        system: 'mtgTax',
        approvalStatus: false,
        approvalDate: null,
        approvalUser: null,
      };
      this.setItem(['mtgVoidAuditRecord', voidItem]);
      this.setIsVisible(['mtgVoidAuditRecord', true]);
    },
    async upsertAuditTransactionForVoids(item) {
      const updatedItem = { ...item };
      updatedItem.businessdate = updatedItem.businessdate
        ? toIsoDate(updatedItem.businessdate) : null;
      if (!this.mtgSettingItem.noAuditRecordOnVoids) {
        await this.upsertTaxPaymentAudits({
          item: [updatedItem],
        });
      }
      if (updatedItem.auditReason) {
        this.reasonCodeForComments = updatedItem.auditReason;
        this.upsertReasonCode();
      }
    },
    editItem(val) {
      this.activeEditedItem = val;
    },
    async onSaveClick(isItFromSaveNPrint) {
      const isValidForm = this.$refs.crudList.$refs.crudDialog.validateForm();
      if (!isValidForm) return;
      // // Save the transaction
      const mtgTransId = await this.upsertMtgData(true);
      // If Save & print, trigger print after save
      if (isItFromSaveNPrint && mtgTransId) {
        this.printReceipt(mtgTransId);
      }
    },
    handlePayrixSuccess() {
      const crudDialog = this.$refs.crudList && this.$refs.crudList.$refs.crudDialog;
      if (crudDialog) {
        crudDialog.apply();
      }
    },
  },
};
</script>
